import React from "react";
// import * as R from "ramda";

// import CSSModules from "react-css-modules";
// import css from "./styles.scss";

import { Div } from "components/Base";
import SearchBar from "ui-kit/SearchBar/View";
// import ABCSortBy from "./ABCSortBy";
// import Filter from "./Filter";
import { SEARCH_BAR_INSTANCE_ID_SESSION_SECTION } from "../constants";
import { connect } from "react-redux";
import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";
import useDisplay from "Portal/NewPortal/Shared/useDisplay";
import { useMobile } from "Portal/NewPortal/Shared/UseMobile";

const decorate = connect(
  state => ({
    backgroundColor: getBackgroundColor(state)
  }),
  {}
);

const Toolbar = ({ backgroundColor }) => {
  const display = useDisplay();
  const isMobile = useMobile();
  return (
    <Div
      display={display}
      mb={4}
      width={1}
      style={isMobile ? { gap: "16px" } : {}}
    >
      {isMobile && (
        <div
          style={{
            color: "#494949",
            fontSize: "20px",
            fontWeight: "600"
          }}
        >
          Sessions
        </div>
      )}

      <Div width={isMobile ? 1 : 0.5}>
        <SearchBar
          instanceId={SEARCH_BAR_INSTANCE_ID_SESSION_SECTION}
          flex={1}
          mr={isMobile ? 0 : 3}
          placeholder={"Search "}
          height={36}
          {...(backgroundColor ? { bg: backgroundColor } : {})}
        />
      </Div>
      {/*
      <Div display={display} width={isMobile ? 1 : 0.5} style={{ gap: "8px" }}>
        <Filter />
        {!isMobile && <ABCSortBy />}
      </Div>
      */}
    </Div>
  );
};

export default decorate(Toolbar);
